'use client';
import * as React from 'react';
import { motion, useAnimation, type Variants } from 'framer-motion';

interface IconProps {
	isHovered: boolean;
}

const lineVariants: Variants = {
	visible: { pathLength: 1, opacity: 1 },
	hidden: { pathLength: 0, opacity: 0 },
};

export function ChartColumnIcon({ isHovered }: IconProps) {
	const controls = useAnimation();
	const [isMounted, setIsMounted] = React.useState(false);

	React.useEffect(() => {
		setIsMounted(true);
	}, []);

	React.useEffect(() => {
		if (!isMounted) return;

		const animate = async () => {
			if (isHovered) {
				await controls.start((i) => ({
					pathLength: 0,
					opacity: 0,
					transition: { delay: i * 0.1, duration: 0.3 },
				}));
				await controls.start((i) => ({
					pathLength: 1,
					opacity: 1,
					transition: { delay: i * 0.1, duration: 0.3 },
				}));
			} else {
				await controls.start('visible');
			}
		};
		void animate();
	}, [isHovered, controls, isMounted]);

	return (
		<div className='select-none p-2 flex items-center justify-center'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			>
				<path d='M3 3v16a2 2 0 0 0 2 2h16' />
				<motion.path
					variants={lineVariants}
					initial='visible'
					animate={controls}
					custom={0}
					d='M8 17v-3'
				/>
				<motion.path
					variants={lineVariants}
					initial='visible'
					animate={controls}
					custom={1}
					d='M13 17V9'
				/>
				<motion.path
					variants={lineVariants}
					initial='visible'
					animate={controls}
					custom={2}
					d='M18 17V5'
				/>
			</svg>
		</div>
	);
}
